const processServer: ImportMetaEnv = import.meta.env;

export const featureFlags = {
  telemetry: processServer?.VITE_FF_TELEMETRY?.toLowerCase() === 'true',
  comments: processServer?.VITE_FF_COMMENTS?.toLowerCase() === 'true',
};
